import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, Fragment as _Fragment } from "vue"
import _imports_0 from '../../assets/img/add-card/sbp-color.svg'


const _hoisted_1 = { class: "z-10 font-semibold" }
const _hoisted_2 = { class: "flex space-x-2" }
const _hoisted_3 = {
  key: 0,
  src: _imports_0,
  alt: "sbp",
  class: "w-3"
}
const _hoisted_4 = { class: "z-10 text-sm" }
const _hoisted_5 = { class: "z-10 text-2xl font-medium" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["relative flex flex-col rounded-md py-2 px-4 h-[116px] text-grey select-none justify-between overflow-hidden", [
      _ctx.subtitle === 'Редактируемая карта'
        ? 'bg-yellowLight'
        : _ctx.isActive
        ? !_ctx.is_approved
          ? 'bg-[#ffdcdc]'
          : 'bg-yellowLight'
        : 'bg-greyLight',
    ]])
  }, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.title), 1),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.bank === 'Sbp')
        ? (_openBlock(), _createElementBlock("img", _hoisted_3))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.bank_name), 1)
    ]),
    _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.numberCard), 1),
    (_ctx.cash)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, "Поступит " + _toDisplayString(_ctx.cash) + " р.", 1))
      : _createCommentVNode("", true),
    (_ctx.subtitle)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["text-sm mr-auto", _ctx.validateSubtitle(_ctx.subtitle)])
        }, _toDisplayString(_ctx.subtitle), 3))
      : _createCommentVNode("", true),
    (_ctx.checkIcon)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          (_ctx.isActive)
            ? (_openBlock(), _createElementBlock("svg", {
                key: 0,
                onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.editCard && _ctx.editCard(...args)), ["stop"])),
                width: "35",
                height: "35",
                viewBox: "0 0 30 30",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                class: "absolute right-3 top-5 z-10 fill-blue"
              }, [...(_cache[1] || (_cache[1] = [
                _createElementVNode("circle", {
                  cx: "15",
                  cy: "15",
                  r: "15"
                }, null, -1),
                _createElementVNode("path", {
                  d: "M15.8143 11.1852L18.8147 14.1857L12.2995 20.7012L9.62438 20.9965C9.26626 21.0361 8.96369 20.7333 9.00354 20.3752L9.30118 17.6981L15.8143 11.1852ZM20.6704 10.7384L19.2616 9.3296C18.8222 8.89013 18.1095 8.89013 17.67 9.3296L16.3447 10.655L19.3451 13.6555L20.6704 12.3301C21.1099 11.8904 21.1099 11.1779 20.6704 10.7384Z",
                  fill: "white"
                }, null, -1)
              ]))]))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true),
    (_ctx.isActive)
      ? (_openBlock(), _createElementBlock("img", {
          key: 3,
          class: _normalizeClass(["absolute right-0 rounded-br-md", _ctx.type === 'qiwi' ? 'top-0' : 'bottom-0']),
          src: require(`../../assets/img/${_ctx.validateCardIcon()}.svg`),
          alt: "image"
        }, null, 10, _hoisted_7))
      : _createCommentVNode("", true)
  ], 2))
}